import { render, staticRenderFns } from "./SaleHistoryEventReminderSentInfo.vue?vue&type=template&id=b89bc790&scoped=true"
import script from "./SaleHistoryEventReminderSentInfo.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventReminderSentInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89bc790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b89bc790')) {
      api.createRecord('b89bc790', component.options)
    } else {
      api.reload('b89bc790', component.options)
    }
    module.hot.accept("./SaleHistoryEventReminderSentInfo.vue?vue&type=template&id=b89bc790&scoped=true", function () {
      api.rerender('b89bc790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleHistoryEventReminderSentInfo.vue"
export default component.exports